package com.daytimegaming.ourdailyfinances.data.network.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UserResponseDto(
    @SerialName("user_id") val userId: String,
    @SerialName("user_email") val userEmail: String,
    @SerialName("user_first_name") val userFirstName: String? = null,
    @SerialName("user_last_name") val userLastName: String? = null,
    @SerialName("created_at") val createdAt: String,
    @SerialName("subscription") val subscription: SubscriptionDto? = null,
)

@Serializable
data class SubscriptionDto(
    @SerialName("active") val active: Boolean,
    @SerialName("tier") val tier: String,
    @SerialName("billing_history") val billingHistory: List<BillingHistoryDto> = emptyList()
)

@Serializable
data class BillingHistoryDto(
    @SerialName("id") val id: String,
    @SerialName("status") val status: String,
    @SerialName("tier") val tier: String,
    @SerialName("source") val source: String? = null,
    @SerialName("started_at") val startedAt: String,
    @SerialName("expires_at") val expiresAt: String
)

@Serializable
data class UpdateUserRequest(
    @SerialName("user_first_name") val userFirstName: String? = null,
    @SerialName("user_last_name") val userLastName: String? = null,
)

@Serializable
data class DeviceTokenRequest(
    @SerialName("token") val token: String
)
